import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SelectProductVariantPage } from 'src/app/modals/select-product-variant/select-product-variant.page';

const routes: Routes = [
    {
        path: '',
        component: SelectProductVariantPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [SelectProductVariantPage]
})

export class SelectProductVariantPageModule { }
